var map = {
	"./404.svg": 953,
	"./Categories.png": 954,
	"./Edit-menu.svg": 955,
	"./Egg.svg": 956,
	"./Emaier-Header.png": 957,
	"./Qr-4.png": 958,
	"./_duplicate.svg": 959,
	"./_overview.svg": 960,
	"./add-white.svg": 961,
	"./alert.svg": 962,
	"./all_category.svg": 963,
	"./archive.svg": 964,
	"./armchair.svg": 965,
	"./arrow-circle-right.svg": 966,
	"./arrow-left-circle.svg": 967,
	"./arrow-right-circle.svg": 968,
	"./arrow-right.svg": 969,
	"./asc-up-white.svg": 970,
	"./asc.png": 971,
	"./asc.svg": 972,
	"./back-arrow.svg": 973,
	"./barcode-icon.svg": 974,
	"./beverages.svg": 975,
	"./blue-edit-pen.svg": 976,
	"./blue-eye.svg": 977,
	"./box-office.svg": 978,
	"./broken-seat.jpg": 979,
	"./calendar_list.svg": 980,
	"./calender.svg": 366,
	"./chevron-down.svg": 981,
	"./chevron-left.svg": 982,
	"./cinema-mamagement-sidebar.svg": 983,
	"./claendar.svg": 315,
	"./clock-1.svg": 984,
	"./clock.svg": 985,
	"./close-button.svg": 718,
	"./close-white.svg": 720,
	"./close-x.svg": 310,
	"./collapse-up.svg": 986,
	"./collapse.svg": 987,
	"./connection-lost.svg": 364,
	"./consumable-raw-material.svg": 988,
	"./copy.svg": 989,
	"./copy_image_icon.png": 990,
	"./delete-red-light.svg": 991,
	"./delete-red.svg": 727,
	"./delete.svg": 701,
	"./deliver-icon.svg": 992,
	"./desc-down-white.svg": 993,
	"./desc.svg": 994,
	"./distributors-sidebar.svg": 995,
	"./download.svg": 996,
	"./dragndrop.svg": 997,
	"./dragndrop2.svg": 998,
	"./duplicate.svg": 999,
	"./duplicateScreen.svg": 1000,
	"./e-wallet-icon-black.svg": 1001,
	"./edit-pen-blue.svg": 1002,
	"./edit-pen-white.svg": 1003,
	"./edit-pen.svg": 1004,
	"./edit.svg": 1005,
	"./email.png": 1006,
	"./empty-image.svg": 1007,
	"./excel.svg": 1008,
	"./external-link.svg": 1009,
	"./eye.svg": 1010,
	"./filter-icon.svg": 1011,
	"./flag.svg": 1012,
	"./fnb-app-order.svg": 1013,
	"./fnb-beverages.svg": 1014,
	"./fnb-brownie.svg": 1015,
	"./fnb-combo.svg": 1016,
	"./fnb-desert.svg": 1017,
	"./fnb-eatables.svg": 1018,
	"./fnb-make-your-combo.svg": 1019,
	"./fnb-popcorn.svg": 1020,
	"./fnbtransactionIcon.svg": 1021,
	"./fullscreen-icon.svg": 728,
	"./funnel.svg": 1022,
	"./globe.svg": 1023,
	"./green-tick.svg": 1024,
	"./grid-view.svg": 1025,
	"./hide-password.svg": 367,
	"./home-icon.svg": 1026,
	"./home.svg": 1027,
	"./icon-black-play.svg": 1028,
	"./icon-dot.svg": 1029,
	"./icon-fnb.svg": 1030,
	"./icon-marketing.svg": 1031,
	"./icon-no-seat.png": 1032,
	"./icon-no-seat.svg": 1033,
	"./icon-option.svg": 1034,
	"./icon-poin-of-sale.svg": 1035,
	"./icon-recliner.svg": 1036,
	"./icon-report.svg": 1037,
	"./icon-sofa-dark-1.svg": 1038,
	"./icon-sofa-dark.png": 1039,
	"./icon-sofa-dark.svg": 1040,
	"./icon-sofa.svg": 1041,
	"./importfile.svg": 1042,
	"./info.svg": 721,
	"./info2.svg": 1043,
	"./keyboard-icon.svg": 1044,
	"./kitchen_display.svg": 1045,
	"./language-icon.svg": 368,
	"./left-caret.svg": 1046,
	"./link.svg": 1047,
	"./list-view.svg": 1048,
	"./loading.svg": 369,
	"./lock.svg": 1049,
	"./login-password.png": 370,
	"./login-user.png": 371,
	"./logout.svg": 722,
	"./masters-sidebar.svg": 1050,
	"./merchandise.svg": 1051,
	"./minus.svg": 1052,
	"./movie-pass-svg.svg": 710,
	"./movie-rolling.svg": 1053,
	"./mulitSchedule.svg": 1054,
	"./multicurrency.svg": 1055,
	"./multifnb.svg": 1056,
	"./nav-plus.svg": 1057,
	"./new_filter_icon.svg": 1058,
	"./no-image.svg": 1059,
	"./no-schedule.svg": 144,
	"./non-veg-mark.png": 1060,
	"./non-veg-mark.svg": 1061,
	"./notification.svg": 1062,
	"./open-link-blue.svg": 1063,
	"./openPlanned.svg": 1064,
	"./overview.svg": 1065,
	"./overview2.svg": 1066,
	"./pdf-icon.svg": 1067,
	"./pdf.svg": 1068,
	"./pickup-ticket-icon.svg": 1069,
	"./pickupfnb.svg": 1070,
	"./play.svg": 1071,
	"./plus.svg": 1072,
	"./pointofsale-1.svg": 1073,
	"./pointofsale-2.svg": 1074,
	"./pointofsale.png": 1075,
	"./portfolio.svg": 1076,
	"./pos-fnb-no-itmes.svg": 714,
	"./pos-refresh.svg": 1077,
	"./primary/chevron-down.svg": 1078,
	"./primary/download.svg": 1079,
	"./primary/edit.svg": 1080,
	"./primary/filter.svg": 1081,
	"./primary/printer.svg": 1082,
	"./print-icon.svg": 1083,
	"./print.svg": 1084,
	"./question.svg": 1085,
	"./question1.svg": 1086,
	"./question2.svg": 729,
	"./question3.svg": 1087,
	"./recliner-1.svg": 1088,
	"./recliner.png": 1089,
	"./refund-icon.svg": 1090,
	"./reload-icon-pos.svg": 1091,
	"./reload-icon.svg": 1092,
	"./restore.svg": 1093,
	"./right-caret.svg": 1094,
	"./role-management-sidebar.svg": 1095,
	"./save.svg": 1096,
	"./schedule-icon.svg": 1097,
	"./school-calendar.svg": 1098,
	"./search-global-white.svg": 1099,
	"./search-global.svg": 1100,
	"./search.svg": 1101,
	"./searchIcon.svg": 1102,
	"./seat-icon-2.svg": 1103,
	"./seat-icon.svg": 1104,
	"./seat-icons/3-wheelChair.png": 1105,
	"./seat-icons/block_seat_new.png": 1106,
	"./seat-icons/broken-seat-1.svg": 1107,
	"./seat-icons/broken-seat-2.svg": 1108,
	"./select-food.png": 730,
	"./settings.svg": 1109,
	"./show-password.svg": 372,
	"./slider-triangle.svg": 723,
	"./snack.svg": 724,
	"./sort.svg": 1110,
	"./star-empty.svg": 1111,
	"./star-fill.svg": 1112,
	"./success-tick.svg": 1113,
	"./suitcase.svg": 1114,
	"./swap.svg": 1115,
	"./tick-green-item.svg": 731,
	"./tick-green.svg": 1116,
	"./ticket-icon.svg": 1117,
	"./trash.svg": 1118,
	"./unpaid-reservation.svg": 706,
	"./updown-white.svg": 1119,
	"./updown.svg": 1120,
	"./user-attribute.svg": 1121,
	"./user-attributes.svg": 1122,
	"./user-female.svg": 1123,
	"./user-male-white.svg": 1124,
	"./user-male.svg": 1125,
	"./user-profile.svg": 1126,
	"./userProfile.png": 1127,
	"./veg-food-mark-white.png": 1128,
	"./veg-foog-mark-trans.png": 1129,
	"./view.png": 1130,
	"./view.svg": 1131
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 952;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons ^\.\/.*$
// module id = 952
// module chunks = 37